import { configureStore } from "@reduxjs/toolkit";
import RS_Sidebar from "./reducers/reducer-sidebar";
import RS_Authentication from "./reducers/reducer-auth";
import accountReducer from "./reducers/accountSlice";
import reportDocumentReducer from "./reducers/reportDocumentSlice";
import dashboardReducer from "./reducers/dashboardSlice";
import achPaymentReducer from "./reducers/achPaymentSlice";
import submitALoanReducer from "./reducers/submitALoanSlice";
import nsfReducer from "./reducers/nsfSlice";
import RS_Tokens from "./reducers/reducer-tokens";

export const store = configureStore({
  reducer: {
    RS_Sidebar: RS_Sidebar,
    RS_Authentication: RS_Authentication,
    RS_Tokens: RS_Tokens,
    dashboard: dashboardReducer,
    account: accountReducer,
    reportDocument: reportDocumentReducer,
    submitALoan: submitALoanReducer,
    achPayment: achPaymentReducer,
    nsf: nsfReducer,
  },
});
